/*
创建者 李伟(2018.2.03)
*/
<template>
  <div class="conInner">
    <section id="content_wrapper">
      <div class="data">
        <h2>我的评论</h2>
      </div>
      <div class="tip">
        <div class="top"></div>
        <div class="body">
          <img src="//static.kxymall.com/images/gth.jpg">
          <div>
            <h2>温馨提示</h2>
            <p>1、这里将显示您的评论信息。</p>
            <p>2、您可以查看您的评论内容以及管理员的回复等。</p>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
      <div class="tab">
        <ul>
          <li v-bind:class="{'selected':tab==1}"><a v-on:click="changeTab(1)"><span>我的评论</span></a></li>
          <li v-bind:class="{'selected':tab==2}"><a v-on:click="changeTab(2)"><span>待评论的商品</span></a></li>
        </ul>
      </div>
      <div class="box">
        <div class="top"></div>
        <div class="body" v-if="tab==1">
          <div class="empty" v-if="!myCommentList.length">暂无信息</div>
          <table cellspacing="0" cellpadding="3" class="liststyle" style="width: 100%" v-if="myCommentList.length">
            <tbody>
              <tr>
                <th class="evaluate" style="width:60px">评分</th>
                <th class="content" style="width:100px">评价内容</th>
                <th class="title" style="text-align:left">评论商品</th>
                <th class="date" style="width:100px">提交时间</th>
                <th class="status" style="width:75px">状态</th>
              </tr>
            </tbody>
            <tbody>
              <tr class="hovertr" v-for="(row,index) in myCommentList" :key="index">
                <td><span v-if="row.grade == 3">好评</span><span v-if="row.grade == 2">中评</span><span
                    v-if="row.grade == 1">差评</span>
                </td>
                <td class="img"><span v-html="row.content"></span></td>
                <td style="text-align:left">
                  <router-link :to="{ path: '/goods', query: { goodsId: row.goodsId}}" v-bind:title="row.name"
                    target="_blank" class="link blue">
                    {{row.name}}
                  </router-link>
                </td>
                <td>{{row.dateline}}</td>
                <td><span v-if="row.status == 1">审批通过</span><span v-if="row.status == 2">审批拒绝</span><span
                    v-if="row.status != 1 && row.status != 2">待审核</span></td>
              </tr>
            </tbody>
          </table>
          <div class="pager_border" v-if="myCommentList.length">
            <Page ref="pages" :total="dataTotal" show-total :page-size="pageSize" @on-change="changepage" size="small"
              show-elevator></Page>
          </div>
        </div>
        <div class="body" v-if="tab==2">
          <div class="empty" v-if="!uncommentedOrderList.length">暂无信息</div>
          <table cellspacing="0" cellpadding="3" class="liststyle" style="width: 100%"
            v-if="uncommentedOrderList.length">
            <tbody>
              <tr>
                <th class="checkbox">&nbsp;&nbsp;</th>
                <th>商品图片</th>
                <th>商品名称</th>
                <th>商品编号</th>
                <th>商品价格</th>
                <th>操作</th>
              </tr>
            </tbody>
            <tbody>
              <tr class="hovertr" v-for="(row,index) in uncommentedOrderList" :key="index">
                <td class="checkbox">&nbsp;&nbsp;</td>
                <td class="img">
                  <router-link :to="{ path: '/goods', query: { goods_id: row.items[0].goodsId}}"
                    v-bind:title="row.items[0].name" class="img" target="_blank">
                    <img :src="row.items[0].image" height="55" width="55">
                  </router-link>
                </td>
                <td class="param">
                  <router-link :to="{ path: '/goods', query: { goods_id: row.items[0].goodsId}}"
                    v-bind:title="row.items[0].name" target="_blank">
                    {{row.items[0].name}}
                  </router-link>
                </td>
                <td>{{row.sn}}</td>
                <td>￥{{row.items[0].price}}</td>
                <td>
                  <router-link
                    :to="{ path: '/goods', query: {goods_id: row.items[0].goodsId,comment:1,orderid:row.orderId}}"
                    v-bind:title="row.items[0].name" target="_blank">
                    评论
                  </router-link>
                  <a v-on:click="addFavorite(row.items[0].goodsId)">收藏</a>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pager_border" v-if="uncommentedOrderList.length">
            <Page ref="pages" :total="dataTotal" show-total :page-size="pageSize" @on-change="changepage" size="small"
              show-elevator></Page>
          </div>
        </div>
        <div class="bottom"></div>
      </div>
    </section>
  </div>
</template>
<script>
import { getMyCommentList } from 'api/user.js';
import { getOrderList } from 'api/order.js';
import { favoriteAdd } from '@/api/goods'
export default {
  data() {
    return {
      tab: 1,
      dataTotal: 0,
      pageSize: 10,
      tabOldVal: '',
      myCommentList: [],
      uncommentedOrderList: []
    }
  },
  created() {
    this.getMyCommentList(1);
    let tab = this.$route.query.tab
    if (tab) {
      this.changeTab(tab)
    }
  },
  methods: {
    //添加收藏
    addFavorite(id) {
      let data = {
        goodsId: id,
        type: 1
      }
      favoriteAdd(data).then(res => {
        if (res.resCode === 1) {
          this.isFavorite = true;
        }
        this.$Message.info(res.resDesc);
      })
    },
    //时间格式
    getDate: function (num) {
      var newDate = new Date();
      newDate.setTime(num * 1000);
      return newDate.toLocaleDateString();
    },
    //标签切换
    changeTab: function (n) {
      this.tab = n
      if (n == 1 && this.tabOldVal != n) this.getMyCommentList(1);
      if (n == 2 && this.tabOldVal != n) this.getWaitCommentList(1);
      this.tabOldVal = n;
    },
    //分页切换
    changepage(index) {
      this.$refs['pages'].currentPage = index;
      if (this.tab == 1) this.getMyCommentList(index);
      if (this.tab == 2) this.getWaitCommentList(index);
    },
    //获取评论数据
    getMyCommentList(pageNo) {
      getMyCommentList(pageNo, this.pageSize).then((json) => {
        if (json.resCode == '1') {
          this.myCommentList = json.data.list;
          for (var i in this.myCommentList) {
            this.myCommentList[i].dateline = this.getDate(this.myCommentList[i].dateline);
          }
          this.dataTotal = json.data.total;
        } else {
          this.$Message.info(json.resDesc);
        }
      });
    },
    //获取待评论数据
    getWaitCommentList(pageNo) {
      getOrderList({
        status: '',
        keyword: '',
        hasUncommented: 1,
        pageNo,
        pageSize: this.pageSize
      }).then((json) => {
        if (json.resCode == '1') {
          this.uncommentedOrderList = json.data.list;
          this.dataTotal = json.data.total;
        } else {
          this.$Message.info(json.resDesc);
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// comments.vue?297c83d2